export default __webpack_public_path__ + "static/media/arrow-next.52e5a4bc.svg";